import { useRouter } from 'next/router';
import { useEffect } from 'react';

import {
  SET_WEEKLY_AS_THE_DEFAULT_OPTION_FOR_RWB_EPPO_ID,
  SET_WEEKLY_AS_THE_DEFAULT_OPTION_FOR_RWB_EPPO_ID_VALUES,
} from '~/components/Eppo/constants';
import { useEppoStringAssignment } from '~/components/Eppo/helpers';
import { trackEvent } from '~/components/analytics/analytics';
import { VIEWED_HOME_PAGE } from '~/components/analytics/constants';
import { prepareUrl } from '~/components/utils/search';
import { getSearchFilterBookingType } from '~/components/utils/searchFilters';

import { ExploreMoreServices } from './ExploreMoreServices/ExploreMoreServices';
import { Hero } from './Hero/Hero';
import { HowDoesMadPawsWork } from './HowDoesMadPawsWork/HowDoesMadPawsWork';
import { PageHead } from './PageHead/PageHead';
import { Trust } from './Trust/Trust';
import { FAQS } from './constants';
import { FAQs } from '../../../common/components/FAQs/FAQs';

import type { NextPage } from 'next';
import type { SearchFilters } from '~/common/types/search';

type Props = {
  canonicalUrl: string | null;
  hasValidation: boolean;
  searchFilters: SearchFilters;
};

export const Home: NextPage<Props> = ({ canonicalUrl, searchFilters: serverSideSearchFilters }) => {
  const router = useRouter();

  const isSetWeeklyAsTheDefaultOptionForRWB =
    useEppoStringAssignment(SET_WEEKLY_AS_THE_DEFAULT_OPTION_FOR_RWB_EPPO_ID) ===
    SET_WEEKLY_AS_THE_DEFAULT_OPTION_FOR_RWB_EPPO_ID_VALUES.ON;

  const searchFilters = isSetWeeklyAsTheDefaultOptionForRWB
    ? {
        ...serverSideSearchFilters,
        bookingType: getSearchFilterBookingType(serverSideSearchFilters),
      }
    : serverSideSearchFilters;

  useEffect(() => {
    trackEvent(VIEWED_HOME_PAGE);
  }, []);

  const handleFiltersSave = (newSearchFilters: SearchFilters): void => {
    const url = prepareUrl(newSearchFilters);
    router.push(url);
  };

  return (
    <>
      <PageHead canonicalUrl={canonicalUrl} />
      <Hero handleFiltersSave={handleFiltersSave} searchFilters={searchFilters} />
      <ExploreMoreServices />
      <HowDoesMadPawsWork />
      <Trust />
      <FAQs faqs={FAQS} headingColor="defaultColor" />
    </>
  );
};
